// Angular
import {
	HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,
	HttpResponse,HttpErrorResponse
} from "@angular/common/http"
import { Injectable } from "@angular/core"
import { MatSnackBar } from "@angular/material"
// RxJS
import { Observable } from "rxjs"
import { tap } from "rxjs/operators"
import { environment } from "../../../../../environments/environment"
/**
 * More information there => https://medium.com/@MetonymyQT/angular-http-interceptors-what-are-they-and-how-to-use-them-52e060321088
 */
@Injectable()
export class InterceptService implements HttpInterceptor {
	// intercept request and add token
	constructor(private snackbar: MatSnackBar) { }
	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {

		if (
			request.body &&
			request.body.method &&
			request.body.method.indexOf("connection:connect") !== -1
		) {
			request = request.clone({
				setHeaders: {
					"X-CSRF-Token": environment.tokencsrf,
					"X-OAUTH-TOKEN": environment.openIDToken,
					"X-ATYL-TOKEN": environment.tokenAtyl
				},
			})
		} else {
			request = request.clone({
				setHeaders: {
					"X-AUTH-TOKEN": environment.tokenauth,
					"X-OAUTH-TOKEN": environment.openIDToken,
					"X-ATYL-TOKEN": environment.tokenAtyl
				},
			})
		}
		if (request.method === "POST" || request.method === "PUT") {
			this.shiftDates(request.body)
		}

		return next.handle(request).pipe(
			tap(
				(event) => {
					if (event instanceof HttpResponse) {
						// http response status code
					}
				},
				(error) => {
					!environment.production && console.error(error.status)
					!environment.production && console.error(error.message)
					
					if (error &&
						error instanceof HttpErrorResponse) {
						const resperror=error as HttpErrorResponse;
				    
						//console.log("InterceptService error",resperror);
						if (resperror.status==0) {
							//this.router.navigateByUrl(resperror.url)
							window.location.href=resperror.url;
						}
					}
					
					
					if (
						request && request.body && request.body.method && request.body.method.indexOf("connection:send401") === -1
					) {
						this.snackbar.open(
							"Erreur de communication avec le serveur",
							"",
							{
								duration: 2500,
								panelClass: ["error-snackbar"]
							}
						)
					}
				}
			)
		)
	}
	shiftDates(body) {
		if (body === null || body === undefined) {
			return body
		}

		if (typeof body !== "object") {
			return body
		}

		for (const key of Object.keys(body)) {
			const value = body[key]
			if (value instanceof Date) {
				body[key] = new Date(
					Date.UTC(
						value.getFullYear(),
						value.getMonth(),
						value.getDate(),
						value.getHours(),
						value.getMinutes(),
						value.getSeconds()
					)
				)
			} else if (typeof value === "object") {
				this.shiftDates(value)
			}
		}
	}
}
